import { sessionStorage } from 'src/assets/js/storage';

const mutations = {
  SET_USER (state, user) {
    state.user = user;
    sessionStorage.setItem('user', user);
  },
  SET_TOKEN (state, token) {
    state.token = token;
    sessionStorage.setItem('token', token);
  },
    SET_MATCHID (state, matchId) {
        state.matchId = matchId;
        sessionStorage.setItem('matchId', matchId);
    }
};

export default mutations;




// WEBPACK FOOTER //
// ./src/store/mutations.js